import { format, stripTimeZoneOffset } from '@/utils/dateTime';
import { Typography } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface LegDateProps {
  date?: string;
}

const LegDate: FC<LegDateProps> = ({ date }) => {
  if (!date) {
    return null;
  }

  return (
    <Typography variant="body2" className="text-neutral">
      {format(stripTimeZoneOffset(date), 'EEE, dd MMM yyyy')}
    </Typography>
  );
};

export default LegDate;
